import { useState, useEffect, useCallback } from 'react';
import { CostProduct, CostListResponse } from '../types/costwand.d';
import { apiClient } from '../api/apiClient.tsx';

const DEFAULT_PAGE_SIZE = 20;

export const useCosts = (initialPage = 1) => {
  const [costs, setCosts] = useState<CostProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);

  const fetchCosts = useCallback(async (page: number, pageSize: number = DEFAULT_PAGE_SIZE) => { // Made page a required argument
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient<CostListResponse>(`/costs?page=${page}&page_size=${pageSize}`, { bypassCache: true }); // ADDED: Bypass cache for pagination
      setCosts(response.data);
      // REMOVED: setCurrentPage(response.pagination.page);
      setTotalPages(response.pagination.total_pages);
      setTotalItems(response.pagination.total_items);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch costs.');
      setCosts([]); // Clear data on error
      setTotalPages(1);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, []); // Removed currentPage from dependencies

  useEffect(() => {
    fetchCosts(currentPage); // Call with the current state value
  }, [currentPage, fetchCosts]); // Fetch on mount and when fetchCosts changes

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return {
    costs,
    loading,
    error,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    fetchCosts, // Expose fetchCosts for manual refetching if needed
  };
};